import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  root: (props: any) => ({
    width: props.size,
    height: props.size,
    display: 'inline-block',
    flexShrink: 0,
  }),

  svg: {
    display: 'block',
    width: '100%',
    height: '100%',
  },

  topLeft: (props: any) => ({
    fill: props.topLeft,
  }),

  blue: (props: any) => ({
    fill: props.bottomRight,
  }),
}));
